import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators } from "redux";
import { ApplicationStore } from "src/store";
import { removeScheduleAppointment, updateScheduleAppointment } from "src/store/actions/currentDeal";
import ScheduleEntry from "./ScheduleEntry";

function mapStateToProps({ account, currentDeal, deal, vehicles }: ApplicationStore) {
    const { appointment, vin } = currentDeal;

    return {
        appointmentDate: appointment && appointment.date,
        appointmentTime: appointment && appointment.time,
        dealerPhone: account.phone,
        uuid: deal.uuid,
        vehicle: vehicles.entities[vin!],
    };
}

const mapDispatchToProps = (dispatch: any) =>
    bindActionCreators(
        {
            removeAppointment: removeScheduleAppointment,
            scheduleAppointment: updateScheduleAppointment,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ScheduleEntry));
